"use client";

import { c as _c } from "react/compiler-runtime";
import { useNetworkSpeed } from "@/hooks/use-network-speed";
import { useMediaQuery } from "@/hooks/use-media-query";
import { useRef, useEffect, useState } from "react";
import { useSound } from "@/hooks/use-sound";
import { cn } from "@/lib/util/cn";
let totalVideos = 5;
function getRandomVideo() {
  return Math.floor(Math.random() * totalVideos);
}
function getVideoQuality(networkSpeed, saveData, isMobile = false) {
  if (saveData) return "none";
  switch (networkSpeed) {
    case "fast":
      return "high";
    case "medium":
      return isMobile ? "low" : "high";
    // Use low quality on mobile to save bandwidth
    case "slow":
      return "low";
    default:
      return "none";
  }
}
function getVideoUrl(videoIndex, quality) {
  if (quality === "none") return null;
  const baseUrl = "https://cdn.akashpomal.com/videos";
  switch (quality) {
    case "high":
    case "medium":
      return `${baseUrl}/video-${videoIndex + 1}.mp4`;
    case "low":
      return `${baseUrl}/video-${videoIndex + 1}.webm`;
    default:
      return null;
  }
}
let AudioURLs = ["https://cdn.akashpomal.com/heartbroken.mp3", "https://cdn.akashpomal.com/deception.mp3", "https://cdn.akashpomal.com/altitude-trains.mp3"];
function getAudioUrl(videoIndex) {
  return AudioURLs[videoIndex % AudioURLs.length];
}
export function VideoBackground() {
  const $ = _c(38);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getRandomVideo();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const currentVideoRef = useRef(t0);
  const videoRef = useRef(null);
  const audioRef = useRef(null);
  const [, setIsTransitioning] = useState(false);
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [shouldShowVideo, setShouldShowVideo] = useState(false);
  const {
    canPlayAudio,
    volume
  } = useSound();
  const {
    speed: networkSpeed,
    saveData,
    effectiveBandwidth
  } = useNetworkSpeed();
  let t1;
  if ($[1] !== isMobile || $[2] !== networkSpeed || $[3] !== saveData) {
    t1 = getVideoQuality(networkSpeed, saveData, isMobile);
    $[1] = isMobile;
    $[2] = networkSpeed;
    $[3] = saveData;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const videoQuality = t1;
  let t2;
  let t3;
  if ($[5] !== effectiveBandwidth || $[6] !== networkSpeed || $[7] !== saveData || $[8] !== videoQuality) {
    t2 = () => {
      const shouldShow = videoQuality !== "none" && effectiveBandwidth > 0.5 && !saveData;
      setShouldShowVideo(shouldShow);
      console.log("Network conditions:", {
        speed: networkSpeed,
        bandwidth: effectiveBandwidth,
        saveData,
        videoQuality,
        shouldShow
      });
    };
    t3 = [networkSpeed, effectiveBandwidth, saveData, videoQuality];
    $[5] = effectiveBandwidth;
    $[6] = networkSpeed;
    $[7] = saveData;
    $[8] = videoQuality;
    $[9] = t2;
    $[10] = t3;
  } else {
    t2 = $[9];
    t3 = $[10];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[11] !== canPlayAudio || $[12] !== isMobile || $[13] !== shouldShowVideo || $[14] !== volume) {
    t4 = () => {
      const video = videoRef.current;
      const audio = audioRef.current;
      if (!shouldShowVideo) {
        return;
      }
      if (audio && isMobile) {
        if (canPlayAudio) {
          audio.muted = false;
          audio.volume = volume;
          audio.src = getAudioUrl(currentVideoRef.current);
        } else {
          audio.muted = true;
        }
      } else {
        if (video && !isMobile) {
          if (canPlayAudio) {
            video.muted = false;
            video.volume = volume;
          } else {
            video.muted = true;
          }
        }
      }
    };
    t5 = [canPlayAudio, volume, shouldShowVideo, isMobile];
    $[11] = canPlayAudio;
    $[12] = isMobile;
    $[13] = shouldShowVideo;
    $[14] = volume;
    $[15] = t4;
    $[16] = t5;
  } else {
    t4 = $[15];
    t5 = $[16];
  }
  useEffect(t4, t5);
  let t6;
  if ($[17] !== isMobile || $[18] !== shouldShowVideo || $[19] !== videoQuality) {
    t6 = () => {
      const video_0 = videoRef.current;
      if (!video_0 || !shouldShowVideo) {
        return;
      }
      const updateVideoSrc = videoIndex => {
        const videoUrl = getVideoUrl(videoIndex, videoQuality);
        if (videoUrl) {
          video_0.src = videoUrl;
        }
      };
      updateVideoSrc(currentVideoRef.current);
      const handleVideoEnd = async () => {
        setIsTransitioning(true);
        video_0.style.opacity = "0";
        await new Promise(_temp);
        if (isMobile) {
          console.log("ended video, restarting same video on mobile", currentVideoRef.current);
          return;
        }
        currentVideoRef.current = (currentVideoRef.current + 1) % totalVideos;
        console.log("ended video, switching to next one", currentVideoRef.current);
        updateVideoSrc(currentVideoRef.current);
        ;
        try {
          await video_0.play();
          video_0.style.opacity = "1";
          setIsTransitioning(false);
        } catch (t7) {
          const error = t7;
          console.log("Video play failed:", error);
          video_0.style.opacity = "1";
          setIsTransitioning(false);
        }
      };
      video_0.addEventListener("ended", handleVideoEnd);
      return () => {
        video_0.removeEventListener("ended", handleVideoEnd);
      };
    };
    $[17] = isMobile;
    $[18] = shouldShowVideo;
    $[19] = videoQuality;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== shouldShowVideo || $[22] !== videoQuality) {
    t7 = [shouldShowVideo, videoQuality];
    $[21] = shouldShowVideo;
    $[22] = videoQuality;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  useEffect(t6, t7);
  if (!shouldShowVideo) {
    return null;
  }
  const t8 = isMobile ? "object-fill" : "object-cover";
  let t9;
  if ($[24] !== t8) {
    t9 = cn("pointer-events-none relative mx-auto h-full w-full max-w-prose object-center", "transition-opacity duration-1000 ease-in-out", t8);
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  const t10 = isMobile || !canPlayAudio;
  const t11 = networkSpeed === "fast" || networkSpeed === "medium" ? "auto" : "metadata";
  let t12;
  if ($[26] !== isMobile || $[27] !== t10 || $[28] !== t11 || $[29] !== t9) {
    t12 = <div className="pointer-events-none fixed inset-0 flex justify-center"><video ref={videoRef} className={t9} playsInline={true} autoPlay={true} loop={isMobile} muted={t10} preload={t11} /></div>;
    $[26] = isMobile;
    $[27] = t10;
    $[28] = t11;
    $[29] = t9;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== canPlayAudio || $[32] !== isMobile) {
    t13 = isMobile && <audio ref={audioRef} className="hidden" autoPlay={true} muted={!canPlayAudio} preload="auto" />;
    $[31] = canPlayAudio;
    $[32] = isMobile;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="pointer-events-none fixed inset-0 mx-auto max-w-prose"><div className="h-full w-full bg-white/30 dark:bg-black/20" /></div>;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== t12 || $[36] !== t13) {
    t15 = <>{t12}{t13}{t14}</>;
    $[35] = t12;
    $[36] = t13;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  return t15;
}
function _temp(resolve) {
  return setTimeout(resolve, 1000);
}